unit Search.PeriodTypes;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.DB, XData.Web.Client, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.Buttons;

type
  TfrmPeriodTypes = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    wcPeriodTypes: TXDataWebClient;
    dsPeriodTypes: TDataSource;
    wdsPeriodTypes: TXDataWebDataSet;
    dgdbaPeriodTypes: TTMSFNCDataGridDatabaseAdapter;
    WebButton1: TButton;
    WebButton2: TButton;
    wdsPeriodTypesAutoNo: TIntegerField;
    wdsPeriodTypesDescription: TStringField;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    edtPeriodTypesPC: TEdit;
    procedure WebButton2Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure TMSFNCDataGrid1CellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
    iPeriodTypesPC , iPeriodTypesMaxPC : Integer;

    procedure LoadPeriodTypes;

  public
    { Public declarations }
    iPeriodTypeAutoNo : Integer;
    sPeriodTypeDescription : String;
  protected procedure LoadDFMValues; override; end;

var
  frmPeriodTypes: TfrmPeriodTypes;

implementation

{$R *.dfm}

uses
  stfmssystem.connection;

procedure TfrmPeriodTypes.LoadPeriodTypes;
var
  sJsonParams : String;
  procedure OnError(Error: TXDataClientError);
    begin
      LoadPeriodTypes;
    end;
  procedure OnResult(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadPeriodTypes;
        end
      else
        begin
          wdsPeriodTypes.Close;
          wdsPeriodTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsPeriodTypes.Open;

        end;
    end;

  procedure OnResultPC(Response : TXDataClientResponse);
    begin
      iPeriodTypesMaxPC := Integer(TJSObject(Response.Result)['value']);

      edtPeriodTypesPC.Text := IntToStr(iPeriodTypesPC) + ' of ' + IntToStr(iPeriodTypesMaxPC);
      sJsonParams := '{"PageCount":' + IntToStr(iPeriodTypesPC) + '}';

      wcPeriodTypes.RawInvoke('IstfmsloadsService.Get_PeriodTypes_View',[sJsonParams],@OnResult,@OnError);
    end;

begin
  wcPeriodTypes.RawInvoke('IstfmsloadsService.Get_PeriodTypes_MaxPC',[],@OnResultPC,@OnError);
end;

procedure TfrmPeriodTypes.TMSFNCDataGrid1CellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  dgdbaPeriodTypes.SetActiveRecord(ARow);

  sPeriodTypeDescription := dgdbaPeriodTypes.FieldAtColumn[1].AsString;
  iPeriodTypeAutoNo := dgdbaPeriodTypes.FieldAtColumn[0].AsInteger;
end;

procedure TfrmPeriodTypes.WebButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmPeriodTypes.WebButton2Click(Sender: TObject);
begin
  iPeriodTypeAutoNo := -1;
  sPeriodTypeDescription := '';
  Close;
end;

procedure TfrmPeriodTypes.WebFormShow(Sender: TObject);
begin
  iPeriodTypesPC := 1;
  LoadPeriodTypes;
end;

procedure TfrmPeriodTypes.WebSpeedButton1Click(Sender: TObject);
begin

    iPeriodTypesPC := 1;
    LoadPeriodTypes;
end;

procedure TfrmPeriodTypes.WebSpeedButton2Click(Sender: TObject);
begin
  if iPeriodTypesPC > 1 then
    begin
      iPeriodTypesPC := iPeriodTypesPC - 1;
      LoadPeriodTypes;
    end;
end;

procedure TfrmPeriodTypes.WebSpeedButton3Click(Sender: TObject);
begin
  if iPeriodTypesPC < iPeriodTypesMaxPC then
    begin
      iPeriodTypesPC := iPeriodTypesPC + 1;
      LoadPeriodTypes;
    end;
end;

procedure TfrmPeriodTypes.WebSpeedButton4Click(Sender: TObject);
begin
  iPeriodTypesPC := iPeriodTypesMaxPC;
  LoadPeriodTypes;
end;

procedure TfrmPeriodTypes.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  edtPeriodTypesPC := TEdit.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  dgdbaPeriodTypes := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcPeriodTypes := TXDataWebClient.Create(Self);
  dsPeriodTypes := TDataSource.Create(Self);
  wdsPeriodTypes := TXDataWebDataSet.Create(Self);
  wdsPeriodTypesAutoNo := TIntegerField.Create(Self);
  wdsPeriodTypesDescription := TStringField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  edtPeriodTypesPC.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  dgdbaPeriodTypes.BeforeLoadDFMValues;
  wcPeriodTypes.BeforeLoadDFMValues;
  dsPeriodTypes.BeforeLoadDFMValues;
  wdsPeriodTypes.BeforeLoadDFMValues;
  wdsPeriodTypesAutoNo.BeforeLoadDFMValues;
  wdsPeriodTypesDescription.BeforeLoadDFMValues;
  try
    Name := 'frmPeriodTypes';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 480;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Period Types';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 420;
    WebPanel3.Width := 640;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 24;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Select';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 136;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Close';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebSpeedButton1.SetParentComponent(WebPanel3);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 288;
    WebSpeedButton1.Top := 16;
    WebSpeedButton1.Width := 24;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 2;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WebPanel3);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 328;
    WebSpeedButton2.Top := 16;
    WebSpeedButton2.Width := 24;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 3;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(WebPanel3);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 432;
    WebSpeedButton3.Top := 16;
    WebSpeedButton3.Width := 24;
    WebSpeedButton3.Height := 24;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 4;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebPanel3);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 464;
    WebSpeedButton4.Top := 16;
    WebSpeedButton4.Width := 24;
    WebSpeedButton4.Height := 24;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 5;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    edtPeriodTypesPC.SetParentComponent(WebPanel3);
    edtPeriodTypesPC.Name := 'edtPeriodTypesPC';
    edtPeriodTypesPC.Left := 368;
    edtPeriodTypesPC.Top := 16;
    edtPeriodTypesPC.Width := 49;
    edtPeriodTypesPC.Height := 22;
    edtPeriodTypesPC.ChildOrder := 6;
    edtPeriodTypesPC.HeightPercent := 100.000000000000000000;
    edtPeriodTypesPC.Text := '0 of 0';
    edtPeriodTypesPC.WidthPercent := 100.000000000000000000;
    TMSFNCDataGrid1.SetParentComponent(WebPanel1);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 60;
    TMSFNCDataGrid1.Width := 640;
    TMSFNCDataGrid1.Height := 360;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 2;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := dgdbaPeriodTypes;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 2;
    TMSFNCDataGrid1.Columns.Clear;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
    end;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('Search.PeriodTypes.WebPanel1.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('Search.PeriodTypes.WebPanel1.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('Search.PeriodTypes.WebPanel1.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('Search.PeriodTypes.WebPanel1.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('Search.PeriodTypes.WebPanel1.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('Search.PeriodTypes.WebPanel1.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('Search.PeriodTypes.WebPanel1.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('Search.PeriodTypes.WebPanel1.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('Search.PeriodTypes.WebPanel1.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    SetEvent(TMSFNCDataGrid1, Self, 'OnCellClick', 'TMSFNCDataGrid1CellClick');
    TMSFNCDataGrid1.RowCount := 1;
    dgdbaPeriodTypes.SetParentComponent(TMSFNCDataGrid1);
    dgdbaPeriodTypes.Name := 'dgdbaPeriodTypes';
    dgdbaPeriodTypes.Left := 344;
    dgdbaPeriodTypes.Top := 152;
    dgdbaPeriodTypes.Width := 26;
    dgdbaPeriodTypes.Height := 26;
    dgdbaPeriodTypes.Visible := True;
    dgdbaPeriodTypes.Columns.Clear;
    with dgdbaPeriodTypes.Columns.Add do
    begin
      FieldName := 'AutoNo';
      AutoCreated := False;
    end;
    with dgdbaPeriodTypes.Columns.Add do
    begin
      FieldName := 'Description';
      AutoCreated := False;
    end;
    dgdbaPeriodTypes.DataSource := dsPeriodTypes;
    wcPeriodTypes.SetParentComponent(Self);
    wcPeriodTypes.Name := 'wcPeriodTypes';
    wcPeriodTypes.Connection := dmData.dbConnect;
    wcPeriodTypes.Left := 88;
    wcPeriodTypes.Top := 212;
    dsPeriodTypes.SetParentComponent(Self);
    dsPeriodTypes.Name := 'dsPeriodTypes';
    dsPeriodTypes.DataSet := wdsPeriodTypes;
    dsPeriodTypes.Left := 232;
    dsPeriodTypes.Top := 212;
    wdsPeriodTypes.SetParentComponent(Self);
    wdsPeriodTypes.Name := 'wdsPeriodTypes';
    wdsPeriodTypes.Connection := dmData.dbConnect;
    wdsPeriodTypes.Left := 160;
    wdsPeriodTypes.Top := 212;
    wdsPeriodTypesAutoNo.SetParentComponent(wdsPeriodTypes);
    wdsPeriodTypesAutoNo.Name := 'wdsPeriodTypesAutoNo';
    wdsPeriodTypesAutoNo.FieldName := 'AutoNo';
    wdsPeriodTypesDescription.SetParentComponent(wdsPeriodTypes);
    wdsPeriodTypesDescription.Name := 'wdsPeriodTypesDescription';
    wdsPeriodTypesDescription.FieldName := 'Description';
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    edtPeriodTypesPC.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    dgdbaPeriodTypes.AfterLoadDFMValues;
    wcPeriodTypes.AfterLoadDFMValues;
    dsPeriodTypes.AfterLoadDFMValues;
    wdsPeriodTypes.AfterLoadDFMValues;
    wdsPeriodTypesAutoNo.AfterLoadDFMValues;
    wdsPeriodTypesDescription.AfterLoadDFMValues;
  end;
end;

end.